export default __webpack_public_path__ + "static/media/Ficha_Movaflor-1.5573f86f.png";